import { render, staticRenderFns } from "./Tesekkurler.vue?vue&type=template&id=b60fa272&scoped=true&"
import script from "./Tesekkurler.vue?vue&type=script&lang=js&"
export * from "./Tesekkurler.vue?vue&type=script&lang=js&"
import style0 from "./Tesekkurler.vue?vue&type=style&index=0&id=b60fa272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60fa272",
  null
  
)

export default component.exports